import(/* webpackMode: "eager" */ "/app/app/blogs/teach/page.tsx");
